var _circle, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPendingSubmissionRequests = function SvgPendingSubmissionRequests(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F3643F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m11.355 29.936 10 10c8.645-.58 15.806-6.645 18-14.774L26.452 12.258z",
    clipRule: "evenodd",
    opacity: 0.15
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#pending-submission-requests_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.027 11.857h2.116a.643.643 0 0 1 0 1.286H11V14h2.143a.643.643 0 0 1 0 1.286H11v.857h2.143a.643.643 0 0 1 0 1.285H11V20a3.429 3.429 0 0 0 6.857 0v-7.714a3.429 3.429 0 0 0-6.83-.43M28.571 16.117l1.904-2.365c.507-.63 1.525-.272 1.525.537V25.71c0 .81-1.018 1.168-1.525.538l-1.904-2.366z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20 17.857c-.305 0-.595.064-.857.178v-6.178h6.428c1.184 0 2.143.96 2.143 2.143v9.857h-6.603A7.7 7.7 0 0 0 22.143 20c0-1.184-.96-2.143-2.143-2.143m5.143-2.143a1.286 1.286 0 1 0 0-2.571 1.286 1.286 0 0 0 0 2.571m-3.429 0a.857.857 0 1 0 0-1.714.857.857 0 0 0 0 1.714",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.857 19.143c.474 0 .857.383.857.857a4.714 4.714 0 1 0 9.429 0 .857.857 0 1 1 1.714 0 6.43 6.43 0 0 1-5.571 6.372v3.056H17a.857.857 0 1 1 0 1.715h-5.143a.857.857 0 0 1 0-1.715h1.714v-3.056A6.43 6.43 0 0 1 8 20c0-.474.384-.857.857-.857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.571 28.143v-.73a7.72 7.72 0 0 0 3.964-2.699h7.18V26c0 1.183-.96 2.143-2.144 2.143z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pending-submission-requests_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 8h24v24H8z"
  })))));
};
export { SvgPendingSubmissionRequests as ReactComponent };
export default __webpack_public_path__ + "fonts/pending-submission-requests-cb03573248150008762929c4e4da6b7d.svg";